import { combineReducers } from 'redux';
import lodash from 'lodash';

import * as binderActions from 'overview/actions/binders';

function binders(state = {}, action) {
    if (action.type === binderActions.BINDERS_WRITE) {
        const { method, binders } = action.payload;
        const keyedBinders = lodash.keyBy(binders, 'id');

        return method === 'replace'
            ? keyedBinders
            : { ...state, ...keyedBinders };
    }
    return state;
}

function bindersCount(state = 0, action) {
    if (action.type === binderActions.BINDERS_WRITE) {
        return action.payload.bindersCount;
    }
    return state;
}

function filterOptions(state = binderActions.filterOptions, action) {
    return state;
}

function initialOffset(state = 0, action) {
    if (action.type === binderActions.BINDERS_INITIAL_OFFSET) {
        return action.payload;
    }
    return state;
}

function loaded(state = false, action) {
    if (action.type === binderActions.BINDERS_NOTIFY_LOADING) {
        return false;
    }
    if (action.type === binderActions.BINDERS_NOTIFY_LOADED) {
        return action.payload.loadingState;
    }
    return state;
}

function loading(state = false, action) {
    if (action.type === binderActions.BINDERS_NOTIFY_LOADING) {
        return action.payload;
    }
    if (action.type === binderActions.BINDERS_NOTIFY_LOADED) {
        return false;
    }
    return state;
}

function loadingError(state = null, action) {
    if (action.type === binderActions.BINDERS_NOTIFY_LOADING) {
        return null;
    }
    if (action.type === binderActions.BINDERS_NOTIFY_LOADED) {
        return action.payload.loadingError;
    }
    return state;
}

function sortOptions(state = binderActions.sortOptions, action) {
    return state;
}

const bindersOverview = combineReducers({
    binders,
    bindersCount,
    filterOptions,
    initialOffset,
    loaded,
    loading,
    loadingError,
    sortOptions
});

const binderActionsMatcher = /^BINDERS_/;

export default function bindersOverviewReducer(state, action) {
    if (!binderActionsMatcher.test(action.type) && action.type !== '@@INIT') {
        return state;
    }
    if (action.type === binderActions.BINDERS_UNLOAD) {
        return {
            ...state,
            bindersOverview: bindersOverview({}, action)
        };
    }
    return {
        ...state,
        bindersOverview: bindersOverview(state.bindersOverview, action)
    };
}
